import { render, staticRenderFns } from "./SmsCampaigns.vue?vue&type=template&id=58768820&"
import script from "./SmsCampaigns.vue?vue&type=script&lang=js&"
export * from "./SmsCampaigns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports